<template>
  <v-col :cols="cols" :lg="lg" :md="md" :sm="sm" class="text-center ma-0 pa-0">
    <v-input ref="ids_file_input" class="d-none" type="hidden" v-bind="$attrs" v-on="$listeners" />
    <v-file-input
        id="ids_file_input_file_input"
        ref="ids_file_input_file_input"
        class="d-none"
        name="ids_file_input_file_input"
        v-model="file"
    />
    <v-card-subtitle v-if="preview_label" class="ma-0 pa-0 text-small" v-html="preview_label" />
    <app-tooltip v-if="value" :text="clear_search_label">
      <app-btn
          :color="clear_search_color || 'error'"
          :loading="is_loading"
          :max-width="maxWidth"
          :min-width="minWidth"
          @click="clearSearch"
      >
        <v-icon v-if="start_search_icon">{{ clear_search_icon }}</v-icon>{{ clear_search_label }}
      </app-btn>
    </app-tooltip>
    <template v-else>
      <app-tooltip :text="start_search_label">
        <app-btn :color="start_search_color || 'primary'" :loading="is_loading" :max-width="maxWidth" :min-width="minWidth" @click="searchActivator">
          <v-icon v-if="start_search_icon">{{ start_search_icon }}</v-icon>{{ start_search_label }} <app-dt-btn class="app-dt-btn" v-if="download_template" :tooltip="download_template_label" @click="downloadExcelTemplate(download_template)" download elevation="0" fab small/>
        </app-btn>
      </app-tooltip>
    </template>
  </v-col>
</template>
<script>
import TemplateMixin from "@mixins/TemplateMixin";
export default {
  name: 'FileUploader',
  mixins: [TemplateMixin],
  props: {
    name: {
      type: String,
      default: () => 'file-uploader'
    },
    preview_label: {
      type: String,
      default: () => '',
    },
    clear_search_label: {
      type: String,
      default: () => this.parseAttribute('clear_search_claims'),
    },
    clear_search_icon: {
      type: String,
      default: () => 'mdi-close',
    },
    clear_search_color: {
      type: String,
      default: () => 'error',
    },
    start_search_label: {
      type: String,
      default: () => this.parseAttribute('search_claims'),
    },
    download_template_label: {
      type: String,
      default: () => 'download_template',
    },
    download_template: {
      type: String,
      default: () => '',
    },
    start_search_icon: {
      type: String,
      default: () => 'mdi-magnify',
    },
    start_search_color: {
      type: String,
      default: () => 'primary',
    },
    minWidth: {
      type: [String, Number],
      default: () => '120',
    },
    maxWidth: {
      type: [String, Number],
      default: () => 'auto',
    },
    value: {},
    handler: {
      type: Function,
      required: !0,
      default: () => async((file) => file)
    },
    loading: {
      type: Boolean,
      required: true
    },
    all: {
      type: [String, Number],
      default: () => undefined
    },
    cols: {
      type: [Number, String],
      default() {
        return this.all !== undefined ? this.all : 12;
      }
    },
    sm: {
      type: [Number, String],
      default() {
        return this.all !== undefined ? this.all : 6;
      }
    },
    md: {
      type: [Number, String],
      default() {
        return this.all !== undefined ? this.all : 3;
      }
    },
    lg: {
      type: [Number, String],
      default() {
        return this.all !== undefined ? this.all : 4;
      }
    },
  },
  data() {
    return {
      is_loading: false,
      change_triggered: false,
      file: null
    }
  },
  watch: {
    loading(v) {
      this.is_loading = v
    },
    is_loading(v) {
      this.$emit('update:loading', v);
    },
    file(v) {
      this.searchExcelFileInput(v);
    }
  },
  methods: {
    async searchExcelFileInput(files) {
      if (!files || this.change_triggered) return;

      this.change_triggered = true;
      const ids_file_input = this.$refs.ids_file_input;
      const file = files && files.length ? files[0] : files;
      let val;

      this.is_loading = !0;
      try {
        val = await this.handler(file);
        val != undefined && ids_file_input.$emit('input', val)
      } catch (e) {
        console.error(e);
      }

      // this.$emit("handler", file, callback);
      this.is_loading = !1;
    },
    searchActivator() {
      this.$refs.ids_file_input_file_input.$el.querySelector('input').click()
      this.is_loading = !1;
    },
    clearSearch() {
      this.file = null;
      // this.$refs.ids_file_input.$emit('input', '');
      this.$refs.ids_file_input.reset();
      // this.$refs.ids_file_input_file_input.$emit('change', '');
      this.$refs.ids_file_input_file_input.reset();
      this.change_triggered = false;
    },
  },
  mounted() {
    this.is_loading = this.loading;
    this.clearSearch();
  }
}
</script>
<style>
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > tbody > tr > th, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > th, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
  padding: 0 !important;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > th, .v-data-table > .v-data-table__wrapper > table > thead > tr > th, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
  height: auto !important;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
  height: auto !important;
}
</style>
